import React from "react";
import { useTranslation } from "react-i18next";
import banner from "../assets/images/Home Page_Esports_Image.png";

const Banner: React.FC = () => {
  const { t } = useTranslation();

  const handleLoginClick = (): void => {
    console.log("Login button clicked");
    //  https://portal.gamerji.com/login
  };

  return (
    <div className="relative w-full h-[80vh]">
      <img src={banner} alt="Banner" className="w-full h-full object-cover" />

      {/* Centered Text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 sm:px-4 pb-4 sm:pb-6">
        <h1 className="text-white font-oswald font-extrabold text-[32px] sm:text-[40px] md:text-[56px] lg:text-[72px] mb-4 leading-tight drop-shadow-md">
          {t("playwinrep")}
        </h1>

        <p className="text-white font-oswald font-medium text-[18px] sm:text-[24px] md:text-[30px] lg:text-[36px] mb-0 drop-shadow-sm">
          {t("epmore")}
        </p>

        {/* Download & Login Buttons */}
        <div className="mt-6 flex flex-wrap gap-4 items-center justify-center">
          {/* Android App Button */}
          <a
            id="btnPlayStore"
            href="https://play.google.com/store/apps/details?id=com.gamerji.sportsdraft"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width="25.16"
              height="32"
              className="fa-2x text-white mr-[2px]"
            >
              <path
                fill="currentColor"
                d="M293.6 234.3L72.9 13 353.7 174.2 293.6 234.3zM15.3 0C2.3 6.8-6.4 19.2-6.4 35.3l0 441.3c0 16.1 8.7 28.5 21.7 35.3L271.9 255.9 15.3 0zM440.5 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM72.9 499L353.7 337.8 293.6 277.7 72.9 499z"
              />
            </svg>

            <div className="text-left leading-none">
              <p className="text-xs font-medium">Download from</p>
              <p className="text-base font-bold">Play Store</p>
            </div>
          </a>

          <a
            id="btnAppStore"
            href="https://apps.apple.com/in/app/gamerji-esports-gaming-app/id6749573390 "
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20"
          >
            <i className="fa fa-apple fa-2x text-white mr-[2px]"></i>
            <div className="text-left leading-none">
              <p className="text-xs font-medium">Download from</p>
              <p className="text-base font-bold">App Store</p>
            </div>
          </a>
          {/* Login on Website Button */}
          <button
            onClick={handleLoginClick}
            className="flex items-center gap-3 bg-white text-black py-3 px-6 rounded-lg hover:bg-gray-200 transition-all border border-white/30"
          >
            <i className="fa fa-sign-in fa-2x"></i>
            <div className="text-left leading-none">
              <p className="text-xs font-medium">{t("banner.login")}</p>
              <p className="text-base font-bold">{t("banner.onWebsite")}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
